import { Session } from '@supabase/auth-js';
import { supabase } from './supabase-config';
import { log } from '@utils/logging';

let CURRENT_SESSION: Session | null = null;

export const getCurrentUser_synchronous = () => CURRENT_SESSION?.user;

export const getSignedInUser = async () => {
    const sessionResponse = await supabase.auth.getSession();

    // cache most recent response for synchronous access in logging calls
    CURRENT_SESSION = sessionResponse.data.session;

    if (!sessionResponse) {
        return null;
    }

    return sessionResponse.data.session?.user;
};

export const getSession = async (): Promise<Session | null> => {
    const sessionResponse = await supabase.auth.getSession();

    // cache most recent response for synchronous access in logging calls
    CURRENT_SESSION = sessionResponse.data.session;

    if (!sessionResponse) {
        return null;
    }

    return sessionResponse.data.session;
};

// Supabase is incorrectly interpreting the effect of multiple foreign primary keys on the user_events table (and likely others: user_team)
// so it's returning an array of objects instead of a single object. This function will spread the inner array into the parent object.
// See: https://github.com/supabase/supabase-js/issues/536
export function spreadInnerArraySingle<T extends { id: string }>(
    data: T | T[] | null | undefined,
    lookup: (item: T) => [],
): T[] {
    return (data ? (Array.isArray(data) ? data : [data]) : []).map((item: T) => {
        let membership = undefined;
        const array: unknown[] = lookup(item) || [];

        if (item && array.length > 0) {
            membership = array[0];

            if (array.length > 1) {
                // should never happen!
                log(`[spreadInnerArraySingle] array.length > 1: ${item?.id as string}`, { item });
            }
        }

        return {
            ...item,
            membership,
        } as T;
    }) as T[];
}
